<script setup>
import { useToast } from 'primevue/usetoast';

const props = defineProps({
  email: { type: String, required: true },
});

const toast = useToast();
const visible = ref(false);
const pending = ref(false);
const replied = ref(false);
const { t } = useI18n();

const showTemplate = () => {
  if (!visible.value) {
    toast.add({
      severity: 'info',
      summary: t('components.auth.yourEmailIsStillWaitingForVerification'),
      group: 'bc',
    });
    visible.value = true;
  }
};
onMounted(() => {
  showTemplate();
});
const onReply = async () => {
  replied.value = true;
  pending.value = true;
  visible.value = false;

  const { error } = await useApi('/api/auth/resend-token', {
    method: 'POST',
    body: {
      email: props.email,
      tokenType: 'verify-email',
    },
  });
  if (error) {
    toast.add({
      severity: 'error',
      summary: t('components.auth.failedToSendVerificationEmail'),
      detail: t('errors.' + error) || t('errors.INTERNAL_ERROR'),
    });
  } else {
    toast.add({
      severity: 'success',
      summary: t('components.auth.verificationEmailSentSuccessfully'),
      detail: t('components.auth.checkYourInboxAndVerifyYourEmail'),
      life: 4000,
    });
  }

  pending.value = false;
};

const onClose = () => {
  visible.value = false;
};
</script>

<template>
  <div class="flex justify-center">
    <PrimeToast
      position="bottom-center"
      group="bc"
      style="bottom: 60px; max-width: 90vw"
      @close="onClose"
    >
      <template #message="slotProps">
        <div class="flex flex-auto flex-col items-start">
          <div class="flex items-center gap-2">
            <span class="text-xl font-medium">{{ $t('components.auth.yourEmailIsNotVerified') }}</span>
          </div>
          <div class="my-4 text-lg font-medium">
            {{ slotProps.message.summary }}
          </div>
          <PrimeButton
            size="small"
            :label="
              pending
                ? $t('components.auth.sendingVerificationEmail')
                : $t('components.auth.resendVerificationEmail')
            "
            severity="info"
            icon="pi pi-check-circle"
            :loading="pending"
            :disabled="replied"
            class="mx-auto"
            @click="onReply"
          />
        </div>
      </template>
    </PrimeToast>
  </div>
</template>


